// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".join-request-component[data-v-caa8bf60]{background-color:white;min-height:100px;margin-bottom:20px;border:solid 1px #ccc;border-radius:5px;width:100%;margin-top:15px;padding:15px;font-size:18px}\n", ""]);
// Exports
module.exports = exports;
